import { defineComponent as _defineComponent } from 'vue';
import organizerLayout from './organizer.vue';
import defaultLayout from './default.vue';
export default /*#__PURE__*/_defineComponent({
  __name: 'profile',
  setup: function setup(__props) {
    var _useBreakpoint = useBreakpoint(),
      xsOnly = _useBreakpoint.xsOnly;
    var _useI18n = useI18n(),
      locale = _useI18n.locale;
    var layoutComponent = computed(function () {
      return xsOnly.value ? defaultLayout : organizerLayout;
    });
    useNuxt2Meta(function () {
      return {
        // This sets the lang attribute on the html tag
        // This, in turn, allows the cookie consent component to pick up the correct language
        htmlAttrs: {
          lang: locale.value
        }
      };
    });
    return {
      __sfc: true,
      xsOnly: xsOnly,
      locale: locale,
      layoutComponent: layoutComponent
    };
  }
});